import { useConfig } from '@cp/shared/config';
import React, { PropsWithChildren } from 'react';
import { MetricaExperimentsProvider } from 'yandex-metrica-ab-react';
import { isBrowser } from '@cp/utils/browser';

const useVarioqubId = () => {
  const config = useConfig();
  const counterId = config.get('YANDEX_METRIKA_COUNTER_ID');
  return isBrowser && counterId ? `metrika.${counterId}` : undefined;
};

export const VarioqubProvider = (props: PropsWithChildren) => {
  const clientId = useVarioqubId();
  return clientId
    ? // @ts-expect-error missing props.children
      React.createElement(MetricaExperimentsProvider, { clientId }, props.children)
    : React.createElement(React.Fragment, null, props.children);
};
